

import React, { useState } from "react";
import emailjs from "@emailjs/browser"; // EmailJS integration
import "../css/IndividualProduct.css";
import FlipBook from "./FlipBook";

const IndividualProduct = ({ product }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [isFlipBookOpen, setIsFlipBookOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const openPopup = (type) => {
    setPopupType(type);
    setIsPopupOpen(true);
    setSubmitted(false);
    setError("");
    setFormData({ name: "", email: "", phone: "" });
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const { name, email, phone } = formData;
    if (!name || !email || !phone) return "All fields are required!";
    if (!/^\S+@\S+\.\S+$/.test(email)) return "Invalid email format!";
    if (!/^\d{10}$/.test(phone)) return "Phone number must be 10 digits!";
    return "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: `Product Inquiry: ${product.name}`,
      page_url: window.location.href,
    };

    emailjs
      .send(
        "service_i2h82eb", // Replace with your EmailJS Service ID
        "template_rn1vnln", // Replace with your EmailJS Template ID
        templateParams,
        "hjLXq5MC66R977QFn" // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          setSubmitted(true);
          setTimeout(closePopup, 2000);
        },
        (error) => {
          console.error("Email send failed:", error);
          setError("Failed to send the message. Please try again later.");
        }
      );
  };

  return (
    <div className="product-wrapper">
      <div className="product">
        <div className="product__image">
          <img
            src={product.image || "/images/default-product.jpg"}
            alt={product.name}
            className="image"
          />
        </div>

        <div className="product__content">
          <h2 className="product__title">{product.name}</h2>
          {product.description && (
            <p className="product__description">{product.description}</p>
          )}
          <ul className="product__features">
            {product.features.map((feature, index) => (
              <li key={index} className="product__feature-item">
                {feature}
              </li>
            ))}
          </ul>

          <div className="product__buttons">
            <button
              className="product__btn product__btn--contact"
              onClick={() => openPopup("contact")}
            >
              Contact Us
            </button>
            {product.brochure && (
              <button
                className="product__btn product__btn--download"
                onClick={() => setIsFlipBookOpen(true)}
              >
                Download Brochure
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Contact Us Popup Form */}
      {isPopupOpen && popupType === "contact" && (
        <div className="popup">
          <div className="popup__content">
            <button onClick={closePopup} className="popup__close">
              &times;
            </button>
            <h3>Contact Us</h3>
            {!submitted ? (
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                {error && <p className="popup__error">{error}</p>}
                <button type="submit" className="popup__submit">
                  Submit
                </button>
              </form>
            ) : (
              <p className="popup__message">
                Your details have been submitted successfully!
              </p>
            )}
          </div>
        </div>
      )}

      {/* FlipBook Opens Directly on "Download Brochure" Click */}
      {isFlipBookOpen && product.brochure && (
        <FlipBook
          isOpen={isFlipBookOpen}
          setIsOpen={setIsFlipBookOpen}
          pages={product.brochure.pages}
          brochureUrl={product.brochure.url}
        />
      )}
    </div>
  );
};

export default IndividualProduct;
